export function fetchHack(req, opt) {
  const auth = opt.headers['Authorization']
  delete opt.headers['Authorization']
  const api = opt.headers['Dropbox-API-Arg']
  delete opt.headers['Dropbox-API-Arg']
  if (opt.headers['Content-Type'])
    opt.headers['Content-Type'] = 'text/plain; charset=dropbox-cors-hack'
  const url = new URL(req)
  if (api)
    url.searchParams.set('arg', api)
  if (auth)
    url.searchParams.set('authorization',  auth)
  return fetch(url, opt)
}
